import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { t } from "../lib/i18n";
import AdminBadge from "../components/AdminBadge";
import { Crown, Trophy, Medal } from "@phosphor-icons/react";

export default function Leaderboard() {
  const [players, setPlayers] = useState([]);
  useEffect(() => {
    api.get("/leaderboard").then((r) => setPlayers(r.data));
  }, []);

  const podium = players.slice(0, 3);
  const rest = players.slice(3);

  const trophyFor = (i) => {
    if (i === 0) return { Icon: Crown, color: "text-[#E2FF00]" };
    if (i === 1) return { Icon: Trophy, color: "text-[#00E5FF]" };
    return { Icon: Medal, color: "text-[#FF0055]" };
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="border-b border-white/10 pb-6">
        <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FF0055] font-mono">
          // {t.globalStandings}
        </div>
        <h1 className="font-display font-black uppercase italic text-5xl sm:text-6xl mt-2">
          {t.leaderboardTitle}
        </h1>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-10">
        {podium.map((p, i) => {
          const { Icon, color } = trophyFor(i);
          return (
            <Link
              key={p.id}
              to={`/players/${p.id}`}
              data-testid={`podium-${i}`}
              className={`relative overflow-hidden border border-white/10 bg-[#0C0C14] p-6 hover:border-[#FF0055]/60 ${
                i === 0 ? "md:order-2 md:scale-105" : i === 1 ? "md:order-1" : "md:order-3"
              }`}
            >
              <div className="absolute -right-6 -top-6 opacity-10">
                <Icon size={120} weight="fill" />
              </div>
              <div className="relative">
                <div className="flex items-center gap-2">
                  <Icon size={20} weight="fill" className={color} />
                  <span className="text-xs uppercase tracking-[0.3em] font-mono font-bold text-white/60">
                    {t.rank} #{i + 1}
                  </span>
                </div>
                <div className="font-display font-black uppercase italic text-4xl mt-3">{p.handle}</div>
                <div className="text-xs text-white/50 mt-1">{p.real_name} · {p.country}</div>
                <div className="mt-5 grid grid-cols-3 gap-3 font-mono text-sm">
                  <div>
                    <div className="text-[10px] text-white/40 uppercase">{t.wins}</div>
                    <div className="text-[#00E5FF] font-bold text-xl">{p.wins}</div>
                  </div>
                  <div>
                    <div className="text-[10px] text-white/40 uppercase">{t.losses}</div>
                    <div className="text-white/70 font-bold text-xl">{p.losses}</div>
                  </div>
                  <div>
                    <div className="text-[10px] text-white/40 uppercase">{t.pts}</div>
                    <div className="text-[#E2FF00] font-bold text-xl">{p.points}</div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-10 border border-white/10 bg-[#0C0C14]">
        <div className="grid grid-cols-12 px-5 py-3 border-b border-white/10 text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">
          <div className="col-span-1">#</div>
          <div className="col-span-5">{t.blader}</div>
          <div className="col-span-2 text-center">{t.country}</div>
          <div className="col-span-1 text-right">W</div>
          <div className="col-span-1 text-right">L</div>
          <div className="col-span-2 text-right">{t.points}</div>
        </div>
        {rest.map((p, i) => (
          <Link
            to={`/players/${p.id}`}
            key={p.id}
            data-testid={`rank-row-${p.id}`}
            className="grid grid-cols-12 px-5 py-3 border-b last:border-b-0 border-white/5 hover:bg-white/5 items-center"
          >
            <div className="col-span-1 font-mono text-white/50">{i + 4}</div>
            <div className="col-span-5 font-semibold flex items-center gap-2 truncate">
              <span className="truncate">{p.handle}</span>
              {p.is_admin && <AdminBadge />}
            </div>
            <div className="col-span-2 text-center font-mono text-xs text-white/50">{p.country}</div>
            <div className="col-span-1 text-right font-mono text-[#00E5FF]">{p.wins}</div>
            <div className="col-span-1 text-right font-mono text-white/40">{p.losses}</div>
            <div className="col-span-2 text-right font-mono font-bold text-[#E2FF00]">{p.points}</div>
          </Link>
        ))}
        {players.length === 0 && (
          <div className="px-5 py-10 text-center text-white/40 font-mono text-sm">{t.noStandings}</div>
        )}
      </div>
    </div>
  );
}
